import { render, staticRenderFns } from "./unlocked_hint.vue?vue&type=template&id=bb049bc4&scoped=true&"
import script from "./unlocked_hint.vue?vue&type=script&lang=ts&"
export * from "./unlocked_hint.vue?vue&type=script&lang=ts&"
import style0 from "./unlocked_hint.vue?vue&type=style&index=0&id=bb049bc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb049bc4",
  null
  
)

export default component.exports